import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { appOptimoSpinner64Icon } from '../../../icons/optimo-spinner-64';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
  public iconSize = input<string>('64');
  public loadingText = input<string>();

  constructor() {
    injectRegisterIcons(appOptimoSpinner64Icon);
  }
}
